import {
  call, put, fork, takeLatest,
} from 'redux-saga/effects'
import { delay } from 'redux-saga'
import store from 'store'
import * as InvoiceApi from '../../api/invoice'
import {
  FETCH_INVOICE_REQUEST,
  FETCH_INVOICE_SUCCESS,
  FETCH_INVOICE_FAILURE,
  FETCH_INVOICES_REQUEST,
  FETCH_INVOICES_SUCCESS,
  FETCH_INVOICES_FAILURE,
  FETCH_INVOICES_END,
  PAY_INVOICE_REQUEST,
  PAY_INVOICE_SUCCESS,
  PAY_INVOICE_FAILURE,
  FETCH_PAYMENT_PARAMS_REQUEST,
  FETCH_PAYMENT_PARAMS_SUCCESS,
  FETCH_PAYMENT_PARAMS_FAILURE,
  FETCH_PAYMENT_STATUS_REQUEST,
  FETCH_PAYMENT_STATUS_SUCCESS,
  FETCH_PAYMENT_STATUS_FAILURE,
  CHANGE_METHOD_REQUEST,
  CHANGE_METHOD_SUCCESS,
  CHANGE_METHOD_FAILURE,
} from '../../actions/invoice'
import { addError } from '../../actions/notifications'
import { SET_WALLET_BALANCE } from '../../actions/user'

export function* fetchInvoice({ invoiceId }) {
  try {
    const res = yield call(InvoiceApi.fetchInvoice, invoiceId)
    yield put({
      type: FETCH_INVOICE_SUCCESS,
      invoice: res.invoice,
    })
  } catch (err) {
    yield put(addError(err.message))
    yield put({
      type: FETCH_INVOICE_FAILURE,
      error: err.message,
    })
  }
}

export function* watchFetchInvoice() {
  yield takeLatest(FETCH_INVOICE_REQUEST, fetchInvoice)
}

export function* fetchInvoices({ invoiceType, offset = 0 }) {
  try {
    const res = yield call(InvoiceApi.fetchInvoices, invoiceType, offset)
    yield put({
      type: FETCH_INVOICES_SUCCESS,
      invoices: res.invoices,
      invoiceType,
      offset,
    })
    if (res.invoices && res.invoices.length === 0) {
      yield put({
        type: FETCH_INVOICES_END,
      })
    }
  } catch (err) {
    yield put(addError(err.message))
    yield put({
      type: FETCH_INVOICES_FAILURE,
      error: err.message,
    })
  }
}

export function* watchFetchInvoices() {
  yield takeLatest(FETCH_INVOICES_REQUEST, fetchInvoices)
}

export function* payInvoice({ invoiceId, payload }) {
  try {
    const res = yield call(InvoiceApi.payInvoice, invoiceId, payload)
    yield put({
      type: PAY_INVOICE_SUCCESS,
      invoice: res.invoice,
    })
    yield put({
      type: SET_WALLET_BALANCE,
      walletBalance: res.wallet_balance,
    })
    // yield put(addSuccess('Pay Invoice Success'))
  } catch (err) {
    yield put(addError(err.message))
    yield put({
      type: PAY_INVOICE_FAILURE,
      error: err.message,
    })
  }
}

export function* watchPayInvoice() {
  yield takeLatest(PAY_INVOICE_REQUEST, payInvoice)
}

export function* fetchPaymentParams({ invoiceId, method, payload }) {
  try {
    if (method === "ALIPAY_HK") {
      const payload = {
        ...payload,
        os_type: store.get("osType")
      }
      const res = yield call(InvoiceApi.qfPayParams, invoiceId, "ALIPAY_HK", payload)
      
      if (res.method === "alipay_hk") {
        yield put({
          type: FETCH_PAYMENT_PARAMS_SUCCESS,
          method: res.method,
          pay_params: res.pay_params,
          pay_params_string: res.pay_params_string,
          state: res.state,
          ...payload,
        });
        return;
      }
    }
    const paramsResponse = yield call(InvoiceApi.qfPayParams, invoiceId, method, payload)
    if (paramsResponse.method === 'paypal' || paramsResponse.method === 'paypal_auth') {
      yield call(InvoiceApi.redirect, paramsResponse.pay_params_string)
    } else if (paramsResponse.method === 'edda') {
      try {
        yield delay(2000)
        const statusResponse = yield call(InvoiceApi.qfPayStatus, invoiceId, payload)
        yield put({
          type: FETCH_PAYMENT_PARAMS_SUCCESS,
          method: paramsResponse.method,
          pay_params: paramsResponse.pay_params,
          pay_params_string: paramsResponse.pay_params_string,
          state: paramsResponse.state,
          ...payload,
        })
        if (statusResponse.status === 'SUCCESS') {
          yield put({
            type: FETCH_PAYMENT_STATUS_SUCCESS,
          })
        } else {
          yield put({
            type: FETCH_PAYMENT_STATUS_FAILURE,
            error: 'PENDING',
          })
        }
      } catch (statusError) {
        yield put({
          type: FETCH_PAYMENT_PARAMS_SUCCESS,
          method: paramsResponse.method,
          pay_params: paramsResponse.pay_params,
          pay_params_string: paramsResponse.pay_params_string,
          state: paramsResponse.state,
          ...payload,
        })
        yield put(addError(statusError.message))
        yield put({
          type: FETCH_PAYMENT_STATUS_FAILURE,
          error: statusError.message,
        })
      }
    } else {
      yield put({
        type: FETCH_PAYMENT_PARAMS_SUCCESS,
        method: paramsResponse.method,
        pay_params: paramsResponse.pay_params,
        pay_params_string: paramsResponse.pay_params_string,
        state: paramsResponse.state,
        ...payload,
      })
    }
  } catch (paramsError) {
    yield put(addError(paramsError.message))
    yield put({
      type: FETCH_PAYMENT_PARAMS_FAILURE,
      error: paramsError.message,
    })
  }
}

export function* watchFetchPaymentParams() {
  yield takeLatest(FETCH_PAYMENT_PARAMS_REQUEST, fetchPaymentParams)
}

export function* fetchPaymentStatus({ invoiceId, payload }) {
  try {
    yield delay(2000)
    const res = yield call(InvoiceApi.qfPayStatus, invoiceId, payload)
    if (res.status === 'SUCCESS') {
      yield put({
        type: FETCH_PAYMENT_STATUS_SUCCESS,
      })
    } else {
      yield put({
        type: FETCH_PAYMENT_STATUS_FAILURE,
        error: 'PENDING',
      })
    }
  } catch (err) {
    if (store.get('schoolCode') != 'ctfeg') {
      yield put(addError(err.message))
    }
    yield put({
      type: FETCH_PAYMENT_STATUS_FAILURE,
      error: err.message,
    })
  }
}

export function* watchFetchPaymentStatus() {
  yield takeLatest(FETCH_PAYMENT_STATUS_REQUEST, fetchPaymentStatus)
}

export function* changePayMethod({ invoiceId }) {
  try {
    const res = yield call(InvoiceApi.changePayMethod, invoiceId)
    yield put({
      type: CHANGE_METHOD_SUCCESS,
      invoice: res.invoice,
    })
  } catch (err) {
    yield put(addError(err.message))
    yield put({
      type: CHANGE_METHOD_FAILURE,
      error: err.message,
    })
  }
}

export function* watchChangePayMethod() {
  yield takeLatest(CHANGE_METHOD_REQUEST, changePayMethod)
}

export default [
  fork(watchFetchInvoice),
  fork(watchFetchInvoices),
  fork(watchPayInvoice),
  fork(watchFetchPaymentParams),
  fork(watchFetchPaymentStatus),
  fork(watchChangePayMethod),
]
